/**
 * OBNIŻKA CENY (Piotr 7.10). Liczy ją baza (`flat.przelicz_obnizke_ceny`, migracja
 * 20261007081536): spadek 3–30% w ostatnich 60 dniach, nowa cena wcześniej w klastrze niewidziana.
 * Front tylko czyta dwie kolumny i pilnuje dwóch rzeczy, których baza nie zobaczy między
 * projekcjami: okna 60 dni (obniżka sprzed 70 dni nie jest już „obniżką”) i tego, że stara cena
 * jest WYŻSZA od pokazywanej (podwyżek nie pokazujemy nigdzie).
 *
 * Tu, w module zgodnym z Deno, bo wstążka e-maili z alertami (`wstazka.ts`) musi wiedzieć to samo
 * co karta. `src/lib/obnizkaCeny.ts` eksportuje stąd dalej.
 *
 * Gdzie widać: karta — wyróżnik „Cena obniżona” (pastylka albo wstążka), bez przekreślania;
 * strona oferty — przekreślona stara cena przy cenie i zdanie „Cena obniżona o X zł · N dni temu”;
 * dolny pasek z ceną na telefonie — nic (za ciasno).
 */
export const DNI_OBNIZKI = 60;

export interface ObnizkaCeny {
  /** Cena przed obniżką. */
  z: number;
  /** O ile zł taniej. */
  o: number;
  /** Kiedy pojawiła się niższa cena (ISO). */
  kiedy: string;
}

export interface OfertaDoObnizki {
  rent_reduced_from_pln?: number | null;
  rent_reduced_at?: string | null;
  extracted_rent_pln?: number | null;
}

const DZIEN = 24 * 60 * 60 * 1000;

export function obnizkaCeny(oferta: OfertaDoObnizki, teraz: number = Date.now()): ObnizkaCeny | null {
  const z = oferta.rent_reduced_from_pln;
  const na = oferta.extracted_rent_pln;
  const kiedy = oferta.rent_reduced_at;
  if (z == null || na == null || !kiedy || !(z > na)) return null;
  const t = new Date(kiedy).getTime();
  if (Number.isNaN(t) || teraz - t > DNI_OBNIZKI * DZIEN) return null;
  return { z, o: z - na, kiedy };
}
